import { Outlet } from "react-router-dom";
import GlimpseToastContainer from "./components/Toast/toast.component";
import { LayoutProvider } from "./contexts/LayoutContext";

const App = () => {
  return (
    <>
      <LayoutProvider>
        <div className="flex flex-col h-full">
          <GlimpseToastContainer />
          <div className="flex-grow h-auto max-h-[100vh]">
            <Outlet />
          </div>
        </div>
      </LayoutProvider>
    </>
  );
};

export default App;
